import axios from 'axios';
import { payloadUser } from './axios-headers';

const client = axios.create({ baseURL: process.env.REACT_APP_ROOT_API });

export const request = ({ ...options }) => {
    // client.defaults.headers.common.Authorization = authToken();
    client.defaults.headers.common.Authorization = payloadUser();
    const onSuccess = response => response;
    const onError = error => {
        // optionally catch errors and add additional logging here
        // console.log('request', error.response);
        return error.response;
    };

    return client(options).then(onSuccess).catch(onError);
};
